import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/37cbd38e8f71fe22b056abaec4f09eb6.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-dark/85 via-navy-primary/80 to-navy-dark/85"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="max-w-4xl">
          <h1 className="font-serif text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-tight mb-12">
            Strategic Management &<br />
            Marketing Consulting<br />
            <span className="text-gold">for Clinical Practices</span>
          </h1>

          <p className="text-lg text-gray-light max-w-xl leading-relaxed mb-16">
            Operational excellence, digital transformation, and scalable growth
            for modern clinical organizations.
          </p>

          <div className="flex flex-wrap gap-6">
            <Link
              to="/contact"
              className="px-10 py-4 bg-gold text-navy-primary text-base font-semibold rounded-lg hover:bg-gold-light transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Request a Strategy Call
            </Link>
            <Link
              to="/services"
              className="px-10 py-4 border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white hover:text-navy-primary transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Our Services
            </Link>
          </div>

          <p className="mt-16 text-xs uppercase tracking-widest text-gold/60">
            Established in Kentucky
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;